import { Box } from '@mui/material'
import type { SearchResultItem } from '../../types'
import { NoResultsMessage } from '../NoResultsMessage'
import { SearchResultCard } from './SearchResultCard'

type Props = {
  rows: SearchResultItem[]
}

export const CardGrid = (props: Props) => {
  const { rows } = props
  return (
    <Box
      display="grid"
      gap={1}
      gridTemplateColumns={'repeat(auto-fit,18rem)'}
      justifyContent="center"
    >
      {rows.length === 0 ? (
        <Box gridColumn="-1/1" padding={4}>
          <NoResultsMessage />
        </Box>
      ) : null}
      {rows.map((item) => (
        <SearchResultCard key={item.id} searchItem={item} />
      ))}
    </Box>
  )
}
